import { gql, useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useNavigate from '../utils/router/useNavigate';
import UIActions from '../ui/UIActions';
import isSize from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';
import useSlug from '../utils/router/useSlug';
import historyPath from '../utils/url/historyPath';
import HistorySidebar from './history/HistorySidebar';
import PostHistoryWrapper from './history/PostHistoryWrapper';

const POST_HISTORY_REDIRECT_QUERY = gql`
  query PostHistoryRedirect($id: ID!) {
    post(id: $id) {
      id
      isEditing
      version
      histories(first: 1) {
        edges {
          node {
            id
            versionFrom
            versionTo
          }
        }
      }
      ...historyPath_post
      ...PostHistoryWrapper_post
    }
  }
  ${historyPath.fragments.post}
  ${PostHistoryWrapper.fragments.post}
`;

const PostHistoryRedirectView = () => {
  const [postId] = useSlug('postSlug');
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const response = useQuery(POST_HISTORY_REDIRECT_QUERY, {
    variables: { id: postId },
    fetchPolicy: 'no-cache',
  });

  const post = response.data?.post ?? null;

  useEffect(() => {
    dispatch(
      UIActions.openRightPanel(HistorySidebar, {
        postId,
        tab: 'versions',
      }),
    );

    if (!post) {
      return undefined;
    }

    if (isSize(Sizes.SM)) {
      return () => {
        dispatch(UIActions.closeRightPanel());
      };
    }

    const { isEditing, histories, version } = post;
    let from;
    let to;
    if (isEditing) {
      from = histories.edges.length > 0 ? histories.edges[0].node.versionTo : 0;
      to = version;
    } else if (histories.edges.length > 0) {
      from = histories.edges[0].node.versionFrom;
      to = histories.edges[0].node.versionTo;
    } else {
      return undefined;
    }

    navigate(historyPath(post, from, to), { replace: true });
    return undefined;
  }, [post, postId, dispatch, navigate]);

  return <PostHistoryWrapper post={post} />;
};

export default PostHistoryRedirectView;
